import { Component } from '@angular/core';
import { Helper } from 'src/app/shared/helper';
import { LanguageService } from 'src/app/shared/language.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  today: Date = new Date(); // Define today as a Date object
  languages: any[] = [];
  currentLanguage: any = null;
  private readonly defaultContacts = [
    { name: 'Keval Pipaliya', phone: '84695 97893' },
    { name: 'Bhutik Pipaliya', phone: '99047 12754' },
    { name: 'Office', phone: '95866 61298' },
  ];
  constructor(public helper: Helper, private langService: LanguageService) {
    this.languages = this.langService.supportedLanguages;
    // Initialise current language from storage or default
    this.currentLanguage = localStorage.getItem('theme_lang') ?? environment.defaultLang;
    // Subscribe to language changes so footer updates instantly
    this.langService.languagesObservable.subscribe(() => {
      this.currentLanguage = this.langService.languageShorthand;
    });
  }

  onLanguageChange(lang: any): void {
    // Update language via the service; it persists to localStorage
    this.langService.language = lang.code;
    // The subscription will update currentLanguage automatically
    // No full page reload required
  }

  get companyContacts(): Array<{ name: string; phone: string }> {
    const settings = this.helper.adminSettings || {};
    const contacts = [
      {
        name: settings.contactPerson1Name || this.defaultContacts[0].name,
        phone: settings.contactPerson1Phone || this.defaultContacts[0].phone,
      },
      {
        name: settings.contactPerson2Name || this.defaultContacts[1].name,
        phone: settings.contactPerson2Phone || this.defaultContacts[1].phone,
      },
      {
        name: settings.officeName || this.defaultContacts[2].name,
        phone: settings.officePhone || settings.mobile || this.defaultContacts[2].phone,
      },
    ];

    return contacts.filter((contact) => contact.name || contact.phone);
  }

  get companyAddress(): string {
    return this.helper.adminSettings?.address || 'Shree Ranchhod Nagar, Street No. 3, Sant Kabir Road, Imitation Market, Rajkot (Guj).';
  }

  get companyEmail(): string {
    return this.helper.adminSettings?.email || '';
  }

  get companyPhone(): string {
    return this.helper.adminSettings?.mobile || '';
  }

}
